import React from 'react'
import { Provider } from 'react-redux'
import { createRoot } from 'react-dom/client'
import './index.scss'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App'
import { googleTagManager } from './common/scripts'
import { store, persistor } from './redux/store'

googleTagManager(process.env.REACT_APP_GTM_CONTAINER_ID)
const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
)
